import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DevelopmentAPI } from "pages/workspace/process/development/development.service";
const initialState = {
  data: [],
  state: ""
};
export const modulesSlice = createSlice({
  name: "modules",
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(getModules.fulfilled, (state, action) => {
        state.data = action.payload;
        state.state = "success";
      })
      .addCase(getModules.pending, (state, action) => {
        state.state = "pending";
      });
  }
});

export const getModules = createAsyncThunk('sprints/get', async({ query, workspaceId }) => {
  let data = await DevelopmentAPI.getModules(query, workspaceId);
  return data['modules'];

});


export default modulesSlice.reducer;